<div [ngClass]="{'cdk-overlay-dark-backdrop': isCollapsed}" class="dtc-case-custom" (click)="handleClose(false)"></div>
<div class="app_sideDrawer-dtc-case uni-app-sidedrawer-dtc-case dtc-case-custom-sidedrawer"
  [class]="!isCollapsed ? 'collapsed' : ''" #popoverTrigger>
  <div class="sidedrawer" *ngIf="!openAddProtus">
    <div class="box uni-filter-header-dtc-bg uni-filter-header">
      <div class="d-flex uni-filter-posiiton-header">
        <div class="icon-on-left left-decoration-item" [ngClass]="getSeverityClass(dtcDetails?.severity)"
          *ngIf="dtcDetails?.severity">
          {{dtcDetails?.severity | titlecase}}
        </div>
        <div class="chassis-num-box" *ngIf="dtcDetails?.uniqueId">
          <div class="chassis-num">{{dtcDetails?.uniqueId ?? '--'}}</div>
        </div>
        <div *ngIf="syncError">
          <img src="../../../../assets/images/ph_info-light.svg" alt="info" class="h-21px" matTooltip="Not synced with IDM">
        </div>
      </div>
      <div (click)="handleClose(false)" class="cursor justify-content-end uni-filter-posiiton-actions">
        <img src="../../../../assets/images/close-dtc.svg" alt="Close" (click)="handleClose(false)" class="cursor"
          matTooltip="Close" />
      </div>
    </div>
    <div class="info-card uni-filter-info">
      <div class="card-content d-flex make-responsive-entitiesList">
        <div>
          <div class="label"><span matTooltip="DTC ID">DTC ID</span></div>
          <div class="value ellipsis" [ngClass]="{'cursor dtc-id': !hideNavigation}" [matTooltip]="dtcDetails?.dtc"
            (click)="!hideNavigation && navigateToDtc(dtcDetails?._id)">{{dtcDetails?.dtc}}</div>
        </div>
        <div *ngIf="pageType === 'case'">
          <div class="label"><span matTooltip="Case ID">Case ID</span></div>
          <div class="value ellipsis" [matTooltip]="dtcDetails?.caseNumber">{{dtcDetails?.caseNumber ?? '--'}}</div>
        </div>
        <div *ngIf="pageType === 'case'">
          <div class="d-flex" *ngIf="dtcDetails?.protusNumber || dtcDetails?.protusName || !idmUserName">
            <div class="label ellipsis-protus-header" [matTooltip]="translatedText">{{ translatedText }}</div>
            <img alt="Info" *ngIf="!dtcDetails?.protusNumber && !dtcDetails?.protusName && !idmUserName"
            [matTooltip]="translatedText + ' creation requires an IDM ID. Update profile to proceed'" class="h-20" src="../../../../assets/images/info-icon.svg">
          </div>
          <div *ngIf="dtcDetails?.protusNumber || dtcDetails?.protusName" class="d-flex align-center">
            <div class="value ellipsis" [matTooltip]="dtcDetails?.protusName">{{dtcDetails?.protusName ?? '--'}}</div>
            <img *ngIf="dtcDetails?.protusName" src="../../../../assets/images/text-copy.svg" title="Copy" alt="Copy" class="m-40 cursor" (click)="copyProtus(dtcDetails?.protusName)">
          </div>
          <div *ngIf="applicableRules?.protusAdd && !dtcDetails?.protusNumber && !dtcDetails?.protusName && _service.rbacManagement('case_Casedrilldownedit_AddProtus') && idmUserName && (!protusExists || !dtcDetails?.dtcId )"  (click)="openPopover({isClosed: true, type: 'newProtus'})" class="cursor" [matTooltip]="'Add '+translatedText">
            <!-- <img src="../../../../assets/images/protus-add.svg" alt="Close" class="cursor ml-1"
              [matTooltip]="'Edit '+translatedText" (click)="openPopover(true)" /> -->
              <div class="protus-button d-flex gap5 cursor">
                <div>
                  <img src="../../../../assets/images/protus-add.svg" alt="Close" class="cursor ml-1 h-21" />
                </div>
                <div>Add {{ translatedText }}</div>
              </div>
          </div>
          <div *ngIf="applicableRules?.protusAdd && !dtcDetails?.protusNumber && !dtcDetails?.protusName && _service.rbacManagement('case_Casedrilldownedit_AddProtus') && idmUserName && protusExists && dtcDetails?.dtcId">
            <div [matMenuTriggerFor]="protusMenu" class="protus-button d-flex gap5 cursor">
              <img src="../../../../assets/images/protus-add.svg" alt="Menu" class="cursor ml-1 h-21"/>
              <span> Add {{ translatedText }}</span>
            </div>
            <mat-menu #protusMenu="matMenu">
              <div mat-menu-item *ngIf="applicableRules?.protusAdd && !dtcDetails?.protusNumber 
                                                && !dtcDetails?.protusName 
                                                && _service.rbacManagement('case_Casedrilldownedit_AddProtus') 
                                                && idmUserName" (click)="openPopover({isClosed: true, type: 'newProtus'})">
                <span>New {{ translatedText }}</span>
              </div>
              <div mat-menu-item *ngIf="applicableRules?.protusAdd && !dtcDetails?.protusNumber 
                                                && !dtcDetails?.protusName 
                                                && _service.rbacManagement('case_Casedrilldownedit_AddProtus') 
                                                && idmUserName"
                (click)="openPopover({isClosed: true, type: 'reoccurence'})">
                <span>Report Reoccurrence</span>
              </div>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="uni-filter-scrollabe-container">
      <div class="state-dropdown">
        <mat-form-field class="field" appearance="outline" *ngIf="pageType === 'case'">
          <mat-label>State</mat-label>
          <mat-select [disableOptionCentering]="true" [formControl]="state">
            <mat-option class="text-capitalize" *ngFor="let option of stateList" [value]="option?.value" selected>
              {{option?.displayName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="info-row" *ngIf="pageType === 'dtc'">
          <div class="label">State</div>
          <div class="value">{{dtcDetails?.state ?? '-'}}</div>
        </div>
      </div>
      <div class="evidence-box evidence-container" *ngIf="!isAddEvidence && applicableRules?.updateCase">
        <div (click)="addEvidence()" class="evidence-default cursor">
          <div class="d-flex gap2">
            <div><img src="../../../../assets/images/add_circle.svg" alt="Evidence" class="cursor"
                matTooltip="Evidence"/> </div>
            <div>Evidence</div>
          </div>
        </div>
      </div>
      <div class="evidence-box" *ngIf="isAddEvidence && applicableRules?.updateCase">
        <div>
          <div class="evidence-header">
            Evidence
          </div>
          <div class="evidence-name-input">
            <div>
              <mat-form-field class="field" appearance="outline">
                <mat-label>File Name</mat-label>
                <input matInput [formControl]="fileName">
              </mat-form-field>
            </div>
            <div>
              <button mat-raised-button type="submit" class="custom-button-submit" (click)="onFormSubmit()"
                [disabled]="!fileName?.value || !file?.value">Save</button>
            </div>
          </div>
          <div class="m-12">
            <app-file [formControl]="file" [content]="fileContent?.file" [folder]="'documents'"
              [image]="'kb_defaultfile.svg'" [isFileTypeImage]="false" [requiredFileSize]="maxFileSize"
              [requiredFileType]="fileMimeTypes" [startUpload]="startFileBlobUpload"
              (uploadResponse)="uploadResponse($event, 'file')" [pageType]="'dtcCase'">
            </app-file>
            <!-- <ng-container *ngIf="imageUploadForm.get('file')?.errors">
              <mat-error class="lh-30"
                  *ngIf="isUploadFormSubmitted && imageUploadForm.get('file')?.errors['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_FILE_REQUIRED }}
              </mat-error>
              <mat-error class="lh-30" *ngIf="imageUploadForm.get('file')?.errors['requiredFileSize']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_FILE_INVALID_SIZE |
                  replace: '[SIZE]': (maxFileSize | filesize) }}
              </mat-error>
              <mat-error class="lh-30" *ngIf="imageUploadForm.get('file')?.errors['requiredFileType']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_FILE_INVALID_TYPE }}
              </mat-error>
          </ng-container> -->
          </div>
        </div>
      </div>
      <div class="make-responsive-evidencelist evidence-list">
        <div class="file-chip" *ngFor="let file of uploadedEvidences; let i = index">
          <img src="../../../../assets/images/Featured-icon.svg" alt="Evidence" class="cursor" />
          <span class="ellipsis" [matTooltip]="file?.name">{{file?.name ?? 'Evidence'}} </span>
          <div class="d-flex gap5">
            <img src="../../../../assets/images/download_for_offline.svg" alt="Evidence" class="cursor dwnld-icon"
              matTooltip="Download Evidence" (click)="downLoadFile(file?.url, file?.name)" />
            <img src="../../../../assets/images/delete-evidence.svg" alt="Evidence" class="cursor delete-icon"
              *ngIf="applicableRules?.deleteEvidence" matTooltip="Delete Evidence" (click)="deleteFile(i,file?.id)" />
          </div>
        </div>
      </div>
      <div class="state-dropdown" [ngClass]="{'rca-disabled': dtcDetails?.originalState === 'closed'}">
        <mat-form-field class="field" appearance="outline" *ngIf="pageType === 'case' && state?.value === 'closed'">
          <mat-label>RCA</mat-label>
          <mat-select [disableOptionCentering]="true" [formControl]="rca" [required]="state?.value === 'closed'">
            <mat-option class="text-capitalize" *ngFor="let option of rcaList" [value]="option?.value" selected>
              {{option?.displayName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="d-flex">
        <div class="comment-icon">
          <img src="../../../../assets/images/message.svg" alt="Comment" class="cursor" matTooltip="Add Comment" />
        </div>
        <div class="comment-box">
          <mat-form-field class="field" appearance="outline">
            <mat-label>Type your comment here</mat-label>
            <textarea matInput cdkTextareaAutosize [formControl]="comment" #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" (keydown.enter)="saveComment()"></textarea>
          </mat-form-field>
          <div alt="Comment" class="cursor recent-comments" *ngIf="!showComments" (click)="showComment(true)">
            <div class="recent-comments-text">
              <img src="../../../../assets/images/comments.svg" alt="Comment" />&nbsp;Show Comments
              ({{this.commentsList?.length}})
            </div>
          </div>
          <div alt="Comment" class="cursor hide-comments" *ngIf="showComments" (click)="showComment(false)">
            <div class="hide-comments-text">
              <img src="../../../../assets/images/comments.svg" alt="Comment" />&nbsp;Hide Comments
            </div>
          </div>

        </div>
      </div>
      <div *ngIf="showComments && commentsList?.length">
        <div *ngFor="let comment of commentsList">
          <div class="comment-history" *ngIf="showComments">
            <div class="comment-user">
              <img src="../../../../assets/images/userIcon.svg" alt="User" class="cursor" matTooltip="User" />
              <span class="comment-user-name">{{comment?.metadata?.createdBy?.userName ?? 'Username'}}</span><span
                class="comment-time">&nbsp;&nbsp;added a comment
                {{_service?.getLastSeenFormat(comment?.metadata?.createdDate)}}</span>
            </div>
            <div class="comment-text">
              {{comment?.commentText}}
            </div>
          </div>
        </div>
      </div>
      <div class="comment-history" *ngIf="showComments && !commentsList?.length">
        No comments available
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="btn-basket">
      <button mat-raised-button type="submit" class="custom-button-cancel" (click)="handleClose(false)">Cancel</button>
      <button mat-raised-button type="submit" class="custom-button-submit"
        [disabled]="pageType === 'dtc' || (!selectedFileUrls?.length && !actionsPerformed?.deleteEvidence && !actionsPerformed?.updateCase && state?.value === dtcDetails?.originalState) || (state?.value === 'closed' && !rca?.value)"
        (click)="onCaseSubmit()">Submit</button>
    </div>
  </div>

  <div class="popover-content" *ngIf="openAddProtus || openReportReoccurenceForm">
    <app-add-protus-popover [isCollapsed]="protusExists ? openReportReoccurenceForm : openAddProtus" [formType]="formType" [dtcDetails]="dtcDetails" [protusDetails]="protusDetails" (collapse)="openPopover($event)">
    </app-add-protus-popover>
  </div>
</div>